import React, { FC, useEffect } from 'react';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { useIsMounted } from '../../components/hooks/useIsMounted';
import { doctrineAnalytics } from '../../utils/analyticsUtils';
import styles from './nav_document_analyzer_dropdown.module.scss';
import { buildUrlWithParameters } from '../../utils/url-utils/urlUtils';
import { NavDocumentAnalyzerText } from './NavDocumentAnalyzerText';
import { SmallChip } from '../../components/chips/SmallChip';
import { Hyperlink } from '../../components/Hyperlink';
import { NavDropdownTop } from '../components/dropdown-top/NavDropdownTop';
import { NavDropdownContent } from '../components/dropdown-content/NavDropdownContent';
import { NavItemGroup } from '../components/item-group/NavItemGroup';

type Props = {
  cancelHover: (display: boolean, dropdown: string) => void;
  toggle: Function;
  isOpen: boolean;
};

export const NavDocumentAnalyzerDropdown: FC<Props> = ({
  cancelHover,
  isOpen,
  toggle,
}) => {
  const { getIsMounted } = useIsMounted();

  useEffect(() => {
    cancelHover(isOpen, 'document-analyzer');
  }, [isOpen]);

  const openDropdown = () => {
    if (getIsMounted()) {
      toggle();
      doctrineAnalytics('Nav ButtonDocumentAnalyzerClicked');
    }
  };

  const source = 'nav';

  return (
    <>
      <NavItemGroup onClick={openDropdown}>
        <NavDocumentAnalyzerText />
      </NavItemGroup>
      {isOpen && (
        <NavDropdownContent className={styles.container}>
          <NavDropdownTop />
          <ul>
            <li>
              <Hyperlink
                href={buildUrlWithParameters('/document-analyzer', { source })}
                className={styles.link}
              >
                <span className={classNames(styles.title, styles.titleText)}>
                  <FormattedMessage id="navigation/document-analyzer/NavDocumentAnalyzerDropdown.tsx/1" />
                </span>
                <span className={styles.subtitle}>
                  <FormattedMessage id="navigation/document-analyzer/NavDocumentAnalyzerDropdown.tsx/2" />
                </span>
              </Hyperlink>
            </li>
            <li>
              <Hyperlink
                href={buildUrlWithParameters('/document-analyzer/comparison', {
                  source,
                })}
                className={styles.link}
              >
                <span className={styles.title}>
                  <span className={styles.titleText}>
                    <FormattedMessage id="navigation/document-analyzer/NavDocumentAnalyzerDropdown.tsx/3" />
                  </span>

                  <span className={styles.chip}>
                    <SmallChip>
                      <FormattedMessage id="navigation/document-analyzer/NavDocumentAnalyzerDropdown.tsx/5" />
                    </SmallChip>
                  </span>
                </span>
                <span className={styles.subtitle}>
                  <FormattedMessage id="navigation/document-analyzer/NavDocumentAnalyzerDropdown.tsx/4" />
                </span>
              </Hyperlink>
            </li>
          </ul>
        </NavDropdownContent>
      )}
    </>
  );
};
